var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14967 4.40001C6.26692 4.51711 6.33286 4.67597 6.33301 4.84168L6.33301 5.15834C6.33109 5.32369 6.26541 5.48191 6.14967 5.60001L1.86634 9.87501C1.7881 9.95389 1.68161 9.99826 1.57051 9.99826C1.45941 9.99826 1.35291 9.95389 1.27467 9.87501L0.683007 9.28334C0.604621 9.20654 0.560448 9.10142 0.560448 8.99168C0.560448 8.88194 0.604621 8.77681 0.683007 8.70001L4.39134 5.00001L0.683008 1.30001C0.604127 1.22177 0.559758 1.11528 0.559758 1.00418C0.559759 0.893078 0.604127 0.78658 0.683008 0.708344L1.27467 0.125011C1.35291 0.0461307 1.45941 0.00176196 1.57051 0.00176197C1.68161 0.00176198 1.78811 0.0461307 1.86634 0.125011L6.14967 4.40001Z",
    fill: "#878889"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.8103f2743a6f7548cff3606471983bf6.svg";
export { ForwardRef as ReactComponent };